import React, {useState} from "react"
import {FieldTableCellProps} from "../../../../../../render/table/table-cell"
import {isBulkSelection} from "../../../../../../../gd/right-click-menu"
import FieldTaskStatus_TableCellCalculated_Hovered from "./hovered"
import FieldTaskStatus_TableCellCalculated_NotHovered from "./not-hovered"

// const debug = "FieldTaskStatus_TableCellCalculated"
const debug = false

export default function FieldTaskStatus_TableCellCalculated(props: FieldTableCellProps) {

    const [isHovered, setIsHovered]     = useState(false)
    const [showPopover, setShowPopover] = useState(false)
    
    let isEditable: boolean = !props.manager.isReadOnly && props.field.canEdit(props.listItem.item)
    
    const onMouseEnter = () => {
        if (!isEditable) {
            return
        }
        setIsHovered(true)
    }

    const onMouseLeave = () => {
        if (showPopover) {
            return
        }
        
        setIsHovered(false)
    }

    const onValueChange = (value: ID, shouldHidePopover: boolean = true) => {

        props.listItem.task.statusId = value

        const status = gd.session.statuses.get(value)

        // if new status is of closed system type then action required user should be unset
        if (gd.const.systemStatus.isClosed(status.systemStatus)) {
            props.listItem.task.actionRequiredUserId = null
        }

        props.listItem.task.save()

        shouldHidePopover && hidePopover()
    }

    const onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) {
            return
        }
        if (!isEditable) {
            return
        }

        setShowPopover(true)
    }

    const hidePopover = () => {
        setShowPopover(false)
        setIsHovered(false)
    }

    const width = props.column.width

    const style : style = _.clone(props.style) || {} // we need clone here because we add width!
    style.width = width

    debug && console.log(debug, "render() isHovered=", isHovered)

    if (isHovered) {
        return (
            <FieldTaskStatus_TableCellCalculated_Hovered
                className       = {props.className}
                style           = {style}
                field           = {props.field}
                listItem        = {props.listItem}
                showPopover     = {showPopover}
                onMouseEnter    = {onMouseEnter}
                onMouseLeave    = {onMouseLeave}
                onClick         = {onClick}
                onValueChange   = {onValueChange}
                onHidePopover   = {hidePopover}
            />
        )
    } else {
        return (
            <FieldTaskStatus_TableCellCalculated_NotHovered
                className       = {props.className}
                style           = {style}
                field           = {props.field}
                listItem        = {props.listItem}
                column          = {props.column}
                onMouseEnter    = {onMouseEnter}
                onMouseLeave    = {onMouseLeave}
            />
        )
    }
}
